export const DEPOSIT_CLAIM_POD = `/api/v1/financial-coordinator/crypto/deposit/claim/pod`;
export const DEPOSIT_CLAIM_INIT = `/api/v1/financial-coordinator/crypto/deposit/claim/init`;
export const GET_USER_ADDRESS = `/api/v1/user/my/address`;
